import { daisyUIThemes } from './constants/dasyui_themes';
import usingTheme from "./hooks/using_theme";
import withRouter from "./hooks/with_router";
import getTemplate, { templates } from './templates';
import { getUrlSearchParams } from "./helpers/util_helper";
const { template: templateId = templates.selector, theme = daisyUIThemes.light } = getUrlSearchParams();

export default withRouter(usingTheme(getTemplate(templateId), theme));
